import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionSummary, AccordionDetails, } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CustomText, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
var TripItineraryCard = function (_a) {
    var itinerary = _a.itinerary;
    return (_jsxs(WrapperContainer, { "$background": "#fff", "$borderRadius": "24px", "$padding": "24px", style: { border: "1px solid #e0e0e0" }, "$gap": "0.5rem", children: [_jsx(CustomText, { "$fontSize": "20px", "$fontWeight": "800", "$display": "block", "$margin": "0", children: "Trip Itinerary" }), itinerary.map(function (item, idx) {
                var isFirst = idx === 0;
                return (_jsxs(Accordion, { defaultExpanded: isFirst, disableGutters: true, elevation: 0, sx: {
                        background: "transparent",
                        "&:before": { display: "none" },
                        borderTop: idx === 0 ? "none" : "1px solid #eee",
                    }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { sx: { color: "#5f6368" } }), sx: {
                                padding: 0,
                                minHeight: "64px",
                                "& .MuiAccordionSummary-content": { margin: "12px 0" },
                            }, children: _jsxs(CustomText, { "$fontSize": "16px", "$fontWeight": "700", "$color": "#202124", children: ["Day ", item.day, ": ", item.title] }) }), _jsx(AccordionDetails, { sx: { padding: "0 0 24px 0" }, children: _jsx(CustomText, { "$fontSize": "14px", "$color": "#5f6368", style: {
                                    whiteSpace: "pre-wrap",
                                    lineHeight: "1.6",
                                    display: "block",
                                }, children: item.description }) })] }, idx));
            })] }));
};
export default TripItineraryCard;
